export default __webpack_public_path__ + "4486fc4d8e0ac09d815b46fc1c55a661.png";